// src/components/media360/ui/ExperienceList.jsx
import React from "react";
import { Message } from "semantic-ui-react";
import { ExperienceCard } from "./ExperienceCard";

export function ExperienceList({
  experiences,
  loading,
  error,
  buildPlayerUrlFromExperience,
  onDeleteExperience,
  disabled,
}) {
  if (error) {
    return (
      <Message negative>
        <Message.Header>Error</Message.Header>
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {String(error?.message || error)}
        </pre>
      </Message>
    );
  }

  if (!loading && (!experiences || experiences.length === 0)) {
    return (
      <Message info>
        <Message.Header>No hay experiencias todavía</Message.Header>
        <p>Sube un vídeo o una imagen para que aparezca aquí.</p>
      </Message>
    );
  }

  return (
    <div>
      {experiences?.map((exp) => (
        <ExperienceCard
          key={exp.groupKey}
          exp={exp}
          buildPlayerUrlFromExperience={buildPlayerUrlFromExperience}
          onDeleteExperience={onDeleteExperience}
          disabled={disabled}
        />
      ))}
    </div>
  );
}
